// sizing and positioning tag filter so we can have a cool x-scroll on it for mobile

import { Utility, getTargetContainersExceptPageOverlay } from '../utility/utility_controller'

var bindOnContentReady = function () {
	window.laytheme.on('content_ready', function (typeOfContentThatIsReady) {
		var $target = getTargetContainersExceptPageOverlay(typeOfContentThatIsReady)

		var $grids = $target.find('.thumbs-collection-region')
		if ($grids.length > 0) {
			sizeFilters()
		}
	})

	window.laytheme.on('overlayshown', function ($target) {
		// only do all this once per page overlay:
		if ($target.hasClass('lay-overlay-was-opened-at-least-once')) {
			return
		}
		var $grids = $target.find('.thumbs-collection-region')
		if ($grids.length > 0) {
			sizeFilters()
		}
	})
}

var sizeFilters = function () {
	switch (Utility.screenSize) {
		case 'desktop':
		case 'tablet':
			jQuery('.one-col-row .lay-thumbnailgrid-filter-wrap').each(function () {
				var $tagFilter = jQuery(this).find('.lay-thumbnailgrid-tagfilter')
				if ($tagFilter.length > 0 && $tagFilter.hasClass('mobile-one-line')) {
					$tagFilter.css({
						width: '',
						paddingLeft: '',
						paddingRight: '',
						transform: '',
					})
				}

				var $catFilter = jQuery(this).find('.lay-thumbnailgrid-filter')
				if ($catFilter.length > 0 && $catFilter.hasClass('mobile-one-line')) {
					$catFilter.css({
						width: '',
						paddingLeft: '',
						paddingRight: '',
						transform: '',
					})
				}
			})
			break
		case 'phone':
			// only size this if thumbnailgrid is only element in row, hm not sure, just want to make sure it is a thumbnailgrid that is 100% width on mobile
			jQuery('.one-col-row .lay-thumbnailgrid-filter-wrap').each(function () {
				var windowWidthWithoutScrollbar = document.documentElement.clientWidth

				var $tagFilter = jQuery(this).find('.lay-thumbnailgrid-tagfilter')
				if ($tagFilter.length > 0 && $tagFilter.hasClass('mobile-one-line')) {
					var $col = jQuery(this).closest('.col')
					var rect = $col[0].getBoundingClientRect()
					var paddingLeft = rect.left
					var paddingRight = windowWidthWithoutScrollbar - (rect.left + rect.width)

					$tagFilter.css({
						width: windowWidthWithoutScrollbar + 'px',
						paddingLeft: paddingLeft + 'px',
						paddingRight: paddingRight + 'px',
						transform: 'translateX( -' + paddingLeft + 'px )',
					})
				}

				var $catFilter = jQuery(this).find('.lay-thumbnailgrid-filter')
				if ($catFilter.length > 0 && $catFilter.hasClass('mobile-one-line')) {
					var $col = jQuery(this).closest('.col')
					var rect = $col[0].getBoundingClientRect()
					var paddingLeft = rect.left
					var paddingRight = windowWidthWithoutScrollbar - (rect.left + rect.width)

					$catFilter.css({
						width: windowWidthWithoutScrollbar + 'px',
						paddingLeft: paddingLeft + 'px',
						paddingRight: paddingRight + 'px',
						transform: 'translateX( -' + paddingLeft + 'px )',
					})
				}
			})
			break
	}
}

var i = function () {
	bindOnContentReady()
	jQuery(window).on('window_width_changed', function () {
		sizeFilters()
	})
}

var thumbnailgrid_tagfilter_sizing_controller = {
	i: i,
}

export default thumbnailgrid_tagfilter_sizing_controller
